import React, { FormEvent, ReactElement } from 'react';
import {
  Button, Heading, LoaderButton, Text,
} from 'idsk-react-components';
import { Message } from 'slovlex-idsk-react-components';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import CheckDataTable from '../component/CheckDataTable';
import scrollToTop from '../../../function/scrollToTop';
import useFieldErrorMessages from '../../../hooks/useFieldErrorMessages';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  loading: boolean;
  clearStatus: () => void;
  isUpdate?: boolean;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const CheckDataStep6 = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  loading,
  clearStatus,
  isUpdate,
  onChange,
}: Props): ReactElement => {
  const { getFieldErrorMessage, clearFieldErrorMessage } = useFieldErrorMessages();
  return (
    <div className="prispevok-vestnika-step-pages">
      <Heading className="page-title" size="xl">
        Skontrolujte zadané údaje a prílohy
      </Heading>
      {getFieldErrorMessage('cislo') && (
        <Message onClear={() => clearFieldErrorMessage('cislo')} type="error">
          <Heading
            className="check-data-error-message"
            size="m"
          >{getFieldErrorMessage('cislo')}
          </Heading>
        </Message>
      )}
      <CheckDataTable
        prispevokVestnika={prispevokVestnika}
        onChange={onChange}
        isUpdate={isUpdate}
      />
      <Text className="check-data-step-six__submit-message">
        {isUpdate
          ? 'Kliknutím na Dokončiť úpravu sa príspevok odošle do úložiska a '
          + 'podľa Dátumu zverejnenia uverejní na portáli.'
          : 'Kliknutím na Dokončiť vytvorenie sa príspevok odošle do úložiska a '
          + 'podľa Dátumu zverejnenia uverejní na portáli.'}
      </Text>
      <LoaderButton
        loading={loading}
        type="submit"
        size="large"
        onClick={(e) => onSubmit(e, PrispevokVestnikaStepEnum.CREATE_UPDATE_7)}
      >{isUpdate ? 'Dokončiť úpravu' : 'Dokončiť vytvorenie'}
      </LoaderButton>
      <Button
        className="prispevok-vestnika-step-pages__back-button"
        type="button"
        buttonStyle="third"
        size="large"
        disabled={loading}
        onClick={() => {
          clearStatus();
          if (prispevokVestnika.prilohy?.length > 1) {
            onUpdateField('activeStep', PrispevokVestnikaStepEnum.MAIN_ATTACHMENT_5);
          } else {
            onUpdateField('activeStep', PrispevokVestnikaStepEnum.ATTACHMENTS_4);
          }
          scrollToTop();
        }}
      >
        Späť
      </Button>
    </div>
  );
};

export default CheckDataStep6;
